export default "__VITE_ASSET__CyGM6Loy__"